const BellAlarm = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4989 1.66668C7.31048 1.66668 4.59339 3.98065 4.08569 7.12837L3.11014 13.1768C2.88542 14.57 3.96131 15.8333 5.37257 15.8333H6.75545C7.4631 17.2917 8.84854 18.3333 10.4989 18.3333C12.1492 18.3333 13.5347 17.2917 14.2423 15.8333H15.6252C17.0364 15.8333 18.1123 14.57 17.8876 13.1768L16.9121 7.12837C16.4044 3.98065 13.6873 1.66668 10.4989 1.66668ZM12.7935 15.8333H8.2043C8.76895 16.6145 9.60401 17.0833 10.4989 17.0833C11.3938 17.0833 12.2288 16.6145 12.7935 15.8333Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.21419 1.85963C5.4519 2.10991 5.44171 2.50551 5.19143 2.74322C4.20592 3.67922 3.46832 4.87216 3.08554 6.21349C2.99082 6.54542 2.64495 6.73771 2.31303 6.64299C1.9811 6.54827 1.78881 6.2024 1.88353 5.87047C2.32905 4.30926 3.18685 2.92316 4.3306 1.83686C4.58089 1.59915 4.97648 1.60934 5.21419 1.85963ZM15.7836 1.85963C16.0213 1.60934 16.4169 1.59915 16.6672 1.83686C17.8109 2.92316 18.6687 4.30926 19.1142 5.87047C19.209 6.2024 19.0167 6.54827 18.6847 6.64299C18.3528 6.73771 18.007 6.54542 17.9122 6.21349C17.5295 4.87216 16.7919 3.67922 15.8063 2.74322C15.5561 2.50551 15.5459 2.10991 15.7836 1.85963Z"
    />
  </svg>
)

export default BellAlarm
